import { trackShopByFilterEvent } from '../../../utils/metrics/listingsMetrics';

class ToolbarShopBy {
  constructor() {
    this.searchOpened = this.searchOpened.bind(this);
    this.searchClosed = this.searchClosed.bind(this);
    this.toggleDropdown = this.toggleDropdown.bind(this);
    this.fireShopBySelectEvent = this.fireShopBySelectEvent.bind(this);
    this.onHeaderUnfocus = this.onHeaderUnfocus.bind(this);
    this.windowWidth = $(window).width();

    this.initBehavior();
  }

  el() {
    return $('.pc-ToolBar-shopBy');
  }

  dropdown() {
    return this.el().find('.pc-OverlayDropdown');
  }

  // Private

  initBehavior() {
    $(document).bind('pcToolbar.searchOpened', this.searchOpened);
    $(document).bind('pcToolbar.searchClosed', this.searchClosed);
    $(document).on('click', '.pc-ToolBar-shopBy:visible', this.toggleDropdown);
    $(document).on('mouseleave', '.pc-ToolBar', this.onHeaderUnfocus);
    $(document).on(
      'click',
      '.pc-OverlayDropdown-shopByCategories-toggle',
      this.toggleCategoryList
    );

    return $(document).on(
      'click',
      '.pc-ToolBar-shopBy-link',
      this.fireShopBySelectEvent
    );
  }

  // Private (event handlers)

  searchOpened(e) {
    return this.el().hide();
  }

  searchClosed(e) {
    return this.el().show();
  }

  toggleDropdown(e) {
    e.stopPropagation();
    const dropdownEl = this.dropdown();
    trackShopByFilterEvent(!dropdownEl.is(':visible'));

    return ProductCatalog.OverlayDropdown.open(e, dropdownEl);
  }

  onHeaderUnfocus(e) {
    if (this.windowWidth > 700) {
      $('.pc-OverlayDropdown').hide();
    }
  }

  fireShopBySelectEvent(e) {
    const el = $(e.target);
    return CustomInk.Metrics.fireEvent(
      'shop by filter', el.text().trim(), null
    );
  }

  toggleCategoryList() {
    const $el = $(this);
    const $filterGroup = $el.parent();
    CustomInk.Metrics.fireEvent(
      'shop by filter',
      'Show more',
      'expanded'
    );
    const $toggleSection = $filterGroup.children(
      '.pc-OverlayDropdown-shopByCategories-toggleSection'
    );
    $toggleSection.slideDown();
    $el.fadeOut(500);
  }
}

jQuery(() => (ProductCatalog.ToolbarShopBy = new ToolbarShopBy()));
